<template>
  <form v-if="formState == 'NEW'" @submit.prevent="vincularTag">
    <div :class="{'has-error':errors.has('serialNumber')}">
      <div class="form-tag-activate">
        <b>TAG Número</b>
        <input v-validate data-vv-rules="required|numeric" class="form-control input-tag-number" type="text" name="serialNumber"
          v-model="serialNumber" placeholder="0000000000" :id="vehicle">
      </div>
      <button class="btn btn-activate" type="submit" name="button">
        Ativar
      </button>
    </div>
    <div class="help-block">
      {{errors.first('serialNumber')}}
    </div>
  </form>

  <form v-else-if="formState == 'OLD'">
    <div :class="{'has-error':errors.has('serialNumber')}">
      <div class="form-tag-activate" >
        <b>TAG Número</b>
        <p class="cell-activated-tag">{{ serialNumber }}</p>
      </div>
      <button class="btn btn-activate-tag" type="button" name="button">
        Ativo
      </button>
    </div>
  </form>
</template>

<style lang="scss" scoped>
  .help-block {
    position: relative;
    line-height: 10px;
    font-size: 0.85em;
    color: #a94442;
  }

  .form-tag-activate {
    display: inline-block;
    width: 108px;
  }

  .input-tag-number {
    width: 108px !important;
  }

  .cell-activated-tag {
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    border-radius: 5px;
    background-color: #EEE;
    border: 1px solid #D1D1D1;
    font-weight: normal;
    padding: 2px 5px;
    width: 108px;
  }

  @media (max-width: 767px) {
    .form-tag-activate {
      width: 100%;
    }

    .input-tag-number,
    .cell-activated-tag {
      width: 100% !important;
    }

    .help-block {
      margin: -60px 0 0;
    }

    .has-error .btn-activate {
      margin-top: 30px;
    }

    .btn-activate,
    .btn-activate-tag {
      margin-top: 10px;
      width: 100%;
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    .btn-activate,
    .btn-activate-tag {
      padding: 9px 20px 12px !important;
    }
  }
</style>
<script>
  import tag from '../../../services/tag';
  import MessageDialog from '../../../components/message-dialog.vue';
  import { EventBus } from '../../../event-bus.js'

  //var vm;
  export default {
    props: {
      'vehicle': Number
    },
    data() {
      return {
        serialNumber: undefined,
        formState: 'NEW',
        promise: undefined
      }
    },
    created() {
      let vm = this;
      EventBus.$on("barcode", function(barcode, vehicleId) {
        if(vehicleId == vm.vehicle)
          vm.serialNumber = barcode;
      });
    },
    methods: {
      vincularTag() {
        this.promise = this.$validator.validateAll().then(success => {
          let req = {
            serialNumber: this.serialNumber.replace(/^[^0-9]*/g, ''),
            vehicleId: this.vehicle
          }
          return success && tag.activateTagSite(req);
        }).then( response => {

          if(response.status.code == 0){
            this.formState = 'OLD';

            return MessageDialog.show({
              headerClass: 'modal-success',
              title: 'Ativação de TAG',
              message: 'Seu TAG foi ativado com sucesso!',
              type: 'OK'
            })

          }
        }).catch(error => {
          
          if (error.msg && error.msg.includes('[vee-validate]')) {
            return false;
          }
          
          this.$emit('deactivatetagLoading');

          return MessageDialog.show({
            headerClass: 'modal-danger',
            title: 'Erro',
            message: error.data.status.message,
            type: 'OK'
          })
        });

        this.$emit('activetagLoading', this.promise);

      }
    },
  }
</script>



// WEBPACK FOOTER //
// ativar-tag-item.vue?78d83871